import React from 'react';

export const Page404: React.FC = () => {
  return (
    <div>
      <h1>404: You look lost...</h1>
    </div>
  );
};
